<template>
  <v-dialog :retain-focus="false" :value="sectionEditor.show" :width="1000" @input="handleClosePopup">
    <div style="background-color: #fff">
      <div class="header-modal">
        <v-card-title class="d-flex justify-space-between align-center" style="padding: 10px 0">
          <span style="color: #0081c7">{{ fields.title }}</span>
          <v-btn icon @click="handleClosePopup">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
      </div>

      <v-card-text style="max-height: 70vh; overflow-y: auto">
        <div class="mb-4">
          <label class="label-input">Section</label>
          <v-row>
            <v-col cols="12" md="8">
              <v-text-field v-model="fields.title" label="Name" hide-details />
            </v-col>
            <v-col cols="12" md="4">
              <v-checkbox v-model="fields.enableAnchor" label="Enable Anchor" hide-details />
            </v-col>
          </v-row>
        </div>

        <div class="mb-4">
          <SectionSettingsContainerFuild :settings="fields.settings" :container-page="fields.containerPage" />
        </div>

        <div class="mb-4">
          <label class="label-input">Header</label>
          <div class="group-item mb-4">
            <div class="font-weight-bold mb-2">Title</div>
            <ckeditor :editor="editor" v-model="fields.header.title" :config="editorConfig" />
          </div>

          <v-row class="mb-4">
            <v-col cols="12" md="6">
              <div class="group-item">
                <div class="font-weight-bold mb-2">Left Icon</div>
                <v-checkbox v-model="fields.header.iconLeft.show" label="Show icon" hide-details dense class="mb-2" />
                <UploadImage
                  @callback="handleUploadIconLeft"
                  :image="{ imageSrc: fields.header.iconLeft.src }"
                  :height="`100`"
                  @callbackDelete="handleRemoveIconLeft"
                />
                <v-row class="mt-2">
                  <v-col cols="12" md="6">
                    <v-text-field
                      type="number"
                      v-model.number="fields.header.iconLeft.sizeDesktop"
                      label="Size (Desktop)"
                      min="1"
                      hide-details
                      suffix="px"
                    />
                  </v-col>
                  <v-col cols="12" md="6">
                    <v-text-field
                      type="number"
                      v-model.number="fields.header.iconLeft.sizeMobile"
                      label="Size (Mobile)"
                      min="1"
                      hide-details
                      suffix="px"
                    />
                  </v-col>
                </v-row>
              </div>
            </v-col>
            <v-col cols="12" md="6">
              <div class="group-item">
                <div class="font-weight-bold mb-2">Right Icon</div>
                <v-checkbox v-model="fields.header.iconRight.show" label="Show icon" hide-details dense class="mb-2" />
                <UploadImage
                  @callback="handleUploadIconRight"
                  :image="{ imageSrc: fields.header.iconRight.src }"
                  :height="`100`"
                  @callbackDelete="handleRemoveIconRight"
                />
                <v-row class="mt-2">
                  <v-col cols="12" md="6">
                    <v-text-field
                      type="number"
                      v-model.number="fields.header.iconRight.sizeDesktop"
                      label="Size (Desktop)"
                      min="1"
                      hide-details
                      suffix="px"
                    />
                  </v-col>
                  <v-col cols="12" md="6">
                    <v-text-field
                      type="number"
                      v-model.number="fields.header.iconRight.sizeMobile"
                      label="Size (Mobile)"
                      min="1"
                      hide-details
                      suffix="px"
                    />
                  </v-col>
                </v-row>
              </div>
            </v-col>
          </v-row>
        </div>

        <div class="mb-4">
          <div class="d-flex justify-space-between align-center mb-2">
            <label class="label-input mb-0">Marquee Items</label>
            <v-btn small text color="primary" @click="handleAddMarqueeItem">
              <v-icon size="16">mdi-plus</v-icon>
              <span>Add Item</span>
            </v-btn>
          </div>
          <v-expansion-panels accordion>
            <v-expansion-panel v-for="(item, index) in fields.marquee.items" :key="`marquee-item-${index}`">
              <v-expansion-panel-header>
                <div class="d-flex justify-space-between align-center" style="width: 100%">
                  <span class="line-clamp-1">{{ item.text || `Item ${index + 1}` }}</span>
                  <v-btn icon @click.stop="handleRemoveMarqueeItem(index)">
                    <v-icon size="18" color="#ff6c6c">mdi-delete</v-icon>
                  </v-btn>
                </div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <UploadImage
                  @callback="obj => handleUploadMarqueeItemIcon(obj, index)"
                  :image="{ imageSrc: item.icon }"
                  :height="`80`"
                  @callbackDelete="handleRemoveMarqueeItemIcon(index)"
                />
                <v-text-field v-model="fields.marquee.items[index].text" label="Item text" hide-details class="mt-3" />
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </div>
      </v-card-text>

      <div class="footer-modal">
        <v-card-actions style="padding: 10px 0">
          <v-spacer></v-spacer>
          <v-btn min-width="100" depressed @click="handleClosePopup">Cancel</v-btn>
          <v-btn min-width="100" color="primary" @click="handleSave">Save</v-btn>
        </v-card-actions>
      </div>
    </div>
  </v-dialog>
</template>

<script>
import Editor from 'ckeditor5-custom-build/build/ckeditor';
import { ckeditorConfigFullToolbar } from '@/helpers/editor';
import { updateHtmlFromData } from '../common/html/update.js';
import UploadImage from '@/components/form/uploadFile/UpdateImage.vue';
import SectionSettingsContainerFuild from './common/section-settings-container-fuild.vue';

const defaultMarqueeItems = () => [
  { text: 'Risk-Free Purchase', icon: '' },
  { text: '30-Day Money-Back Guarantee', icon: '' },
  { text: 'Order Processed Within 24 Hours', icon: '' },
];

const defaultHeaderTitle = () =>
  `<h2 style="text-align: center; margin: 0;">
    <span style="color: #ffffff; font-size: 32px;"><strong>Risk-Free </strong></span>
    <span style="color: #ffcc00; font-size: 32px;"><strong>30-Day</strong></span>a
    <span style="color: #ffffff; font-size: 32px;"><strong> Guarantee!</strong></span>
  </h2>`;

const MARQUEE_ICON = 'https://cdn.skyfastimg.com/images/2026/07/01/image-6a449007043fff310e823b70.png?w=500&h=50&q=80';

export default {
  name: 'sowhatbuy-guarantee-marquee-section-editor',
  components: {
    SectionSettingsContainerFuild,
    UploadImage,
  },
  props: {
    sectionEditor: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      editor: Editor,
      editorConfig: ckeditorConfigFullToolbar,
      fields: {
        title: 'Sowhatbuy guarantee marquee',
        enableAnchor: false,
        settings: {
          paddingTop: true,
          paddingBottom: true,
          backgroundColor: '#FFFFFF',
          textColor: '#ffffff',
          overlayColor: '#000000',
          overlayOpacity: 0,
          showOverlay: false,
          backgroundImage: '',
        },
        containerPage: {
          enableStyle: false,
          background: '#FFFFFF',
        },
        header: {
          title: defaultHeaderTitle(),
          iconLeft: {
            show: true,
            src: '',
            sizeDesktop: 72,
            sizeMobile: 48,
          },
          iconRight: {
            show: true,
            src: '',
            sizeDesktop: 72,
            sizeMobile: 48,
          },
        },
        marquee: {
          items: defaultMarqueeItems(),
        },
      },
    };
  },
  mounted() {
    this.applyExtract(this.sectionEditor.sectionExtract);
  },
  watch: {
    sectionEditor: {
      handler(newVal) {
        if (newVal && newVal.sectionExtract) {
          this.applyExtract(newVal.sectionExtract);
        }
      },
      deep: true,
    },
  },
  methods: {
    applyExtract(extract) {
      if (!extract) return;
      this.fields = {
        ...this.fields,
        ...extract,
        settings: { ...this.fields.settings, ...(extract.settings || {}) },
        containerPage: { ...this.fields.containerPage, ...(extract.containerPage || {}) },
        header: {
          ...this.fields.header,
          ...(extract.header || {}),
          iconLeft: { ...this.fields.header.iconLeft, ...((extract.header || {}).iconLeft || {}) },
          iconRight: { ...this.fields.header.iconRight, ...((extract.header || {}).iconRight || {}) },
        },
        marquee: {
          ...this.fields.marquee,
          ...(extract.marquee || {}),
          items: Array.isArray(extract.marquee?.items)
            ? extract.marquee.items.map(item => ({ ...item }))
            : this.fields.marquee.items,
        },
      };
    },
    handleUploadIconLeft(obj) {
      if (!obj || !obj.imageSrc) return;
      this.fields.header.iconLeft.src = obj.imageSrc;
    },
    handleRemoveIconLeft() {
      this.fields.header.iconLeft.src = '';
    },
    handleUploadIconRight(obj) {
      if (!obj || !obj.imageSrc) return;
      this.fields.header.iconRight.src = obj.imageSrc;
    },
    handleRemoveIconRight() {
      this.fields.header.iconRight.src = '';
    },
    handleUploadMarqueeItemIcon(obj, index) {
      if (!obj || !obj.imageSrc) return;
      this.fields.marquee.items[index].icon = obj.imageSrc;
    },
    handleRemoveMarqueeItemIcon(index) {
      this.fields.marquee.items[index].icon = '';
    },
    handleAddMarqueeItem() {
      this.fields.marquee.items.push({ text: 'New item', icon: MARQUEE_ICON });
    },
    handleRemoveMarqueeItem(index) {
      if (this.fields.marquee.items.length <= 1) return;
      this.fields.marquee.items.splice(index, 1);
    },
    handleClosePopup() {
      this.$emit('close');
    },
    handleSave() {
      const updateHtml = updateHtmlFromData.sectionSowhatbuyGuaranteeMarquee(
        this.sectionEditor.section.html,
        this.fields,
      );
      this.$emit('update:section', {
        ...this.sectionEditor.section,
        title: this.fields.title,
        html: updateHtml,
      });
      this.$emit('close');
    },
  },
};
</script>

<style scoped lang="scss">
.group-item {
  padding: 15px 10px;
  border-radius: 10px;
  border: 1px solid #e0e0e0;
}
.label-input {
  font-size: 18px !important;
  font-weight: 500;
  color: #000;
  margin-bottom: 10px;
  display: block;
}
.header-modal {
  position: sticky;
  top: 0;
  left: 0;
  z-index: 999;
  background-color: #fff;
  padding: 0 16px;
  box-shadow: 0px 0px 12px #0000000f;
}
.footer-modal {
  position: sticky;
  padding: 0 16px;
  bottom: 0;
  left: 0;
  z-index: 999;
  background-color: #fff;
  box-shadow: 0px 0px 12px #0000000f;
}
::v-deep .ck-editor__editable_inline {
  min-height: 120px !important;
}
</style>
